import { useState } from "react";

export const useJustBootstrappedMobileAuthentication = (): boolean => {
  const [justBootstrapped] = useState(() => {
    const v = sessionStorage.getItem("justBootstrapped");
    if (v) sessionStorage.removeItem("justBootstrapped");
    return v === "1";
  });

  return justBootstrapped;
};

export const setJustBootstrapped = () => {
  sessionStorage.setItem("justBootstrapped", "1");
};
